import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { IListModalModel } from 'src/app/core/models/interfaces/modal-components-models';
import { IParcelRequestModel } from 'src/app/core/models/interfaces/parcel-model';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'orbit-parcel-inquiry',
  templateUrl: './parcel-inquiry.component.html',
  styleUrls: ['./parcel-inquiry.component.scss'],
})
export class ParcelInquiryComponent extends BaseModal implements OnInit {

  queryForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private loadingService: LoadingService, private modalService: ModalService, private constantService: DoktarConstantsService, private farmApiService: FarmApiService) {
    super()
    super._modalService = modalService
  }

  ngOnInit() {
    this.setupForm()
  }

  setupForm() {
    this.queryForm = this.formBuilder.group({
      CityId: ['', [Validators.required]],
      CityName: ['', [Validators.required]],
      DistrictId: ['', [Validators.required]],
      DistrictName: ['', [Validators.required]],
      PlaceId: ['', [Validators.required]],
      PlaceName: ['', [Validators.required]],
      Block: [''],
      Parcel: ['']
    });
  }

  presentCityModal() {
    this.loadingService.showLoading()
    let that = this
    this.constantService.RequestParcelCityList().subscribe(cityResponse => {

      this.modalService.presentListModal({
        hasConfirmBtn: false,
        confirmBtnText: "general.submit",
        isFullscreen: true,
        isMultiple: false,
        title: "general.city_title",
        itemList: cityResponse.map(t => {
          return { id: t.ConstantId, value: t.ConstantValue } as IListModalModel
        })
      }).then(modalRes => {
        this.loadingService.hideLoading()
        modalRes.modalObj.onDidDismiss().then(dismiss => {
          if (dismiss.role !== "canceled") {
            let city = dismiss.data.selectedItem;
            if (city.id !== this.queryForm.controls.CityId)
              this.queryForm.patchValue({ CityId: city.id, CityName: city.value, DistrictId: -1, DistrictName: "", PlaceId: -1, PlaceName: "" }, { emitEvent: true, onlySelf: true });
            // this.queryForm.patchValue({  }, { emitEvent: true, onlySelf: true });
          }
        })
      })
    })
  }

  presentDistrictModal() {
    let cityId = this.queryForm.controls["CityId"].value;
    if (!isNaN(cityId))
      this.loadingService.showLoading()
    let that = this
    this.constantService.RequestParcelDistrictList(cityId).subscribe(districtResponse => {
      this.modalService.presentListModal({
        hasConfirmBtn: false,
        confirmBtnText: "general.submit",
        isFullscreen: true,
        isMultiple: false,
        title: "general.district_title",
        itemList: districtResponse.map(t => {
          return { id: t.ConstantId, value: t.ConstantValue } as IListModalModel
        })
      }).then(modalResp => {
        this.loadingService.hideLoading()
        modalResp.modalObj.onDidDismiss().then(dismiss => {
          if (dismiss.role != "canceled") {
            let district = dismiss.data.selectedItem;
            if (district.id !== this.queryForm.controls.DistrictId)
              this.queryForm.patchValue({ DistrictId: district.id, DistrictName: district.value, PlaceId: -1, PlaceName: "" }, { emitEvent: true, onlySelf: true });
          }
        });
      });
    });
  }

  presentPlaceModal() {
    let districtId = this.queryForm.controls.DistrictId.value;
    if (!isNaN(districtId))
      this.loadingService.showLoading()
    let that = this
    this.constantService.RequestParcelPlaceList(districtId).subscribe(villageResponse => {
      this.modalService.presentListModal({
        hasConfirmBtn: false,
        confirmBtnText: "general.submit",
        isFullscreen: true,
        isMultiple: false,
        title: "general.village_title",
        itemList: villageResponse.map(t => {
          return { id: t.ConstantId, value: t.ConstantValue } as IListModalModel
        })
      }).then(modalResp => {
        this.loadingService.hideLoading()
        modalResp.modalObj.onDidDismiss().then(dismiss => {
          if (dismiss.role != 'canceled') {
            let place = dismiss.data.selectedItem;
            this.queryForm.patchValue({ PlaceId: place.id, PlaceName: place.value }, { emitEvent: true, onlySelf: true });
          }
        })
      })
    })
  }

  clearFormBody() {
    this.queryForm.reset()
  }

  submitRequest() {
    let controls = this.queryForm.controls
    let payload: IParcelRequestModel = {
      ada: controls.Block.value ? controls.Block.value : 0,
      parsel: controls.Parcel.value,
      placeId: controls.PlaceId.value
    }
    this.farmApiService.ParselRequest(payload).subscribe(response => {
      if (response.IsSuccess && response.Data) {
        let data = response.Data
        let coordinates = [];
        data.geometry.coordinates[0].forEach(t => {
          let check = coordinates.some(a => a[0] == t[0] && a[1] == t[1])
          if (!check)
            coordinates.push(t);
        })
        coordinates.push(coordinates[0])
        data.geometry.coordinates[0] = coordinates
        this.dismiss(data, "areaFound").then();
        this.farmApiService.data = data;
        // this.dismiss(response.Data, "areaFound").then()
      }
      else {
        this.dismiss(null, "areaNotFound").then()
      }
    }, error => {
      this.dismiss(error, "areaNotFound").then()
    })

  }

}
